module.exports = __webpack_public_path__ + "img/logo.8197168f.png";